export function BootstrapAdmin() {
  return (
    <div className="center">
      <div className="card" style={{ maxWidth: 620 }}>
        <h2>Bootstrap Disabled</h2>

        <p className="muted">
          The self-service bootstrap screen is disabled for production hardening.
        </p>

        <p className="muted">
          Admin and Super Admin elevation must now be controlled through secured backend
          role-management workflows, not from a public admin-web page.
        </p>

        <p className="muted">
          If emergency bootstrap is ever required, it should be handled directly by a
          controlled backend/admin process.
        </p>
      </div>
    </div>
  );
}